document.addEventListener("DOMContentLoaded", () => {
  const formInput = document.getElementById("contact-address-input");
  const formSubmitButton = document.getElementById('contact-submit-button');

  const submitHandler = async () => {
    const initialButtonContent = formSubmitButton.innerHTML;
    formSubmitButton.disabled = true;
    formSubmitButton.innerHTML = `<div class="spin-loader-small"></div>`;

    const coverageCheckResult = await checkCoverage(formInput.value.trim());

    if (coverageCheckResult) {
      showCoverageCheckerPopup({});
      showCoverageCheckerStep2({
        address: coverageCheckResult,
        plan: 'none',
        title: 'Great news — Nomad Internet is available at your address',
        subtitle:'We detected strong, high-powered cellular tower service in your immediate sector. You qualify for our maximum speed tier.',
        buttonText: 'SEE PLANS & PRICING',
        footerText: 'Lock in your 14-day risk-free trial offer now'
      });
    }

    formSubmitButton.disabled = false;
    formSubmitButton.innerHTML = initialButtonContent;
  }

  formSubmitButton.addEventListener("click", submitHandler);
  formInput.addEventListener("keyup", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      submitHandler();
    }
  });
});
